const STATUS_LABEL_KEYS = {
  normal: 'cma.status.normal',
  attention: 'cma.status.attention',
  critical: 'cma.status.critical',
  healthy: 'cma.status.healthy',
};

export function getStatusLabelKey(status) {
  return STATUS_LABEL_KEYS[status] || status;
}

export default STATUS_LABEL_KEYS;
